var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"options":_vm.timeOptions,"searchable":false,"close-on-select":true,"show-labels":false,"disabled":_vm.cpDisabled,"placeholder":"Time"},on:{"select":_vm.onSelectTime},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }